import { render, staticRenderFns } from "./passCheck.vue?vue&type=template&id=da32f762&scoped=true"
import script from "./passCheck.vue?vue&type=script&lang=js"
export * from "./passCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da32f762",
  null
  
)

export default component.exports